/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interests_Group_LabelInputs */

const en_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select everything you want to invest in`)
};

const de_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie alles aus, in das Sie investieren möchten`)
};

const pt_br2_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione tudo em que você quer investir`)
};

const tr_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yatırım yapmak istediğiniz her şeyi seçin`)
};

const zh_cn2_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择您想投资的所有类别`)
};

const zh_hk2_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇您想投資的所有類別`)
};

const ko_kr2_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`투자하고 싶은 항목을 모두 선택하세요`)
};

const ru_ru2_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите всё, во что хотите инвестировать`)
};

const es_419_onboarding_v1_interests_group_label = /** @type {(inputs: Onboarding_V1_Interests_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona todo en lo que quieras invertir`)
};

/**
* | output |
* | --- |
* | "Select everything you want to invest in" |
*
* @param {Onboarding_V1_Interests_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interests_group_label = /** @type {((inputs?: Onboarding_V1_Interests_Group_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interests_Group_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interests_group_label(inputs)
	if (locale === "de") return de_onboarding_v1_interests_group_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interests_group_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_interests_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interests_group_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interests_group_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interests_group_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interests_group_label(inputs)
	return es_419_onboarding_v1_interests_group_label(inputs)
});